<ng-progress
  #progressBar
  [trickleSpeed]="10"
  [speed]="10"
  [spinner]="false"
  [thick]="true"
  color="#22c55e"
  [ease]="'linear'"
></ng-progress>
<app-paginacao-loading />
<router-outlet></router-outlet>
